import InventoryList from "./InventoryList.presenter";
export default InventoryList;
